export default __webpack_public_path__ + "static/avatar-03-7206bf0976c281a27336f9e6c6b0dd11.svg";